import { render, staticRenderFns } from "./LcDeleteConfirmDialog.vue?vue&type=template&id=b8191b78&scoped=true"
import script from "./LcDeleteConfirmDialog.vue?vue&type=script&lang=js"
export * from "./LcDeleteConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./LcDeleteConfirmDialog.vue?vue&type=style&index=0&id=b8191b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8191b78",
  null
  
)

export default component.exports